import React from 'react';
import './SingleProjectBanner.css';
import { Link } from 'react-router-dom';
import CommonButton from '../../../utility/components/CommonButton';
import backgroundImage from '../../../assets/img/home-project-banner.webp';
import projectsInfo from '../../project/ProjectsInfo';

export const SingleProjectBanner = ({projectId}) => {
    
    const getProjectById = (projectId) => {
        return projectsInfo.find(project => project.id === projectId);
    };

    const selectedProject = getProjectById(projectId);

    return (
        <div className="single-project-banner">
            <img src={backgroundImage} alt="banner background" className="banner-background" />
            <div className="banner-content">
                <h1 className="banner-title">{selectedProject.name}</h1>
                <Link to={`/projects/${projectId}`}>
                    <CommonButton size='large' presetStyle='light'>View Project</CommonButton>
                </Link>
            </div>
        </div>
    );
};